// Stores some common vuetify form validation rules.

const isPasswordValidFormat = (value) => {
  return value.match(/^[a-zA-Z0-9!@#$%^&*]{6,32}$/g);
}

export default {
  required(value) {
    return value && value.length > 0 || 'This is required.';
  },
  passwordValidity: (value) => {
    if (value && isPasswordValidFormat(value)) {
      return true;
    } else {
      return `The password provided failed to match the minimum requirement rules.
      <br>
      Your password must ONLY contain the letters a to z in either upper or lowercase, the numbers 0 to 9 or the characters ! @ # $ % ^ & *.
      <br>
      In attdition, your password must be a minimum of 6 characters and not exceed 32 characters.`;
    }
  },
  // Allows password to not be provided, otherwise it needs to follow normal rules.
  passwordValidityAllowEmpty: (value) => {
    if (!value || isPasswordValidFormat(value)) {
      return true;
    } else {
      return 'Password must be at least 8 characters long and contain a mixture of upper ' +
        'case letters, lower case letters, numbers and symbols.';
    }
  },
  resourceForbidden(error, self){
      self.$swal({
        title: 'Oops!',
        text: error.response.data.error,
        type: 'error'
      })
      .then(()=>{
        if (this.$router.history.current.name != 'signin') {
          self.$store.dispatch('setToken', null)
          self.$store.dispatch('setUser', null)        
          self.$router.push({
            name: 'signin'
          })
        }
      });
  },   
}